import { render, staticRenderFns } from "./SideBarIcon.vue?vue&type=template&id=3436a686&scoped=true&"
import script from "./SideBarIcon.vue?vue&type=script&lang=js&"
export * from "./SideBarIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3436a686",
  null
  
)

export default component.exports